/**
 * Librarys
 */
import React, { useEffect, useState } from 'react';

/**
 * Estilos
 */
import './App.css';

//import { medicos } from './utils/medicos';
//import { createMedicoCRM } from './objects/medico';

/**
 * Utilerías
 */
//Importar el espacio de almacenamiento de base de datos firestore y las colecciones necesarias
//import { pacientesStore, systems } from './utils/config';

/**
 * Pages
 */
//Page asignada a la reservación de quirófano para cirugía
import ReservarCirugia from './pages/reservar_cirugia';

/**
 * Contenedor general del sitio
 * @returns Devuelve el contenido del sitio
 */
const App = () =>{

  //Estado que indica la versión actual del sitio
  const [version] = useState("1.0.0")

  //const medicosJson = []

  // useEffect(()=>{
  //   console.log("Medicos")
  //   console.log(medicosJson.length)
    

   
   
  //  let sinDuplicados = [];
   
  //  function elementoRepite (valor) {
  //     let vecesRepetidas = 0;
  //     for(let i of sinDuplicados){
  //        if (i.Nombre_correcto == valor) {
  //           vecesRepetidas ++;
  //           if (vecesRepetidas > 0) {
  //              return true;
  //              break;
  //           }
  //        }
  //     }
  //     return false; 
  //  }
   
   
  //  medicosJson.forEach(i => {
  //     if (!elementoRepite(i.Nombre_correcto)){
  //           sinDuplicados.push(i);
  //        } 
  //  })
   
  //  console.log("Medicos Filtrados")
  //  console.log(sinDuplicados.length)
  //  console.log(sinDuplicados)

  // },[medicosJson])

  useEffect(()=>{
    if(version){
      
    }
  },[version])

  // useEffect(()=>{
  //   console.log(medicos)
  //   let create = new Date()
  //   let year = create.getFullYear()
  //   let month = parseInt(create.getMonth() + 1).toString().padStart(2,"0")
  //   let day = parseInt(create.getDay()).toString().padStart(2,"0")
  //   let hour = parseInt(create.getHours()).toString().padStart(2,"0")
  //   let minute = parseInt(create.getMinutes()).toString().padStart(2,"0")
  //   let seconds = parseInt(create.getSeconds()).toString().padStart(2,"0")

  //   let time = year + "-" + month + "-" + day + " " + hour + ":" + minute + ":" + seconds
    


  //   for(let i=0;i<medicos.length;i++){
  //     if(medicos[i].UH){
        
  //       let HU = medicos[i].UH.trim()
  //       let Hospital = ""

  //       switch(HU){
  //         case "AGN":
  //           Hospital = "MAC Aguascalientes Norte"
  //           break
  //         case "AGS":
  //           Hospital = "MAC Aguascalientes Sur"
  //           break
  //         case "BCR":
  //           Hospital = "MediMAC Boca del Rio"
  //           break
  //         case "CAB":
  //           Hospital = "HMAS Los Cabos"
  //           break
  //         case "CUE":
  //           Hospital = "MediMAC Cuemanco"
  //           break
  //         case "CYA":
  //           Hospital = "MAC Celaya"
  //           break
  //         case "ECA":
  //           Hospital = "MediMAC Ecatepec"
  //           break
  //         case "GDL":
  //           Hospital = "MAC Guadalajara"
  //           break
  //         case "GTO":
  //           Hospital = "MediMAC Guanajuato"
  //           break
  //         case "INT":
  //           Hospital = "MAC Interlomas"
  //           break
  //         case "IRA":
  //           Hospital = "MAC Irapuato"
  //           break
  //         case "LEO":
  //           Hospital = "MAC León"
  //           break
  //         case "MER":
  //           Hospital = "MediMAC Merida"
  //           break
  //         case "MEX":
  //           Hospital = "MAC Mexicali"
  //           break
  //         case "MOCH":
  //           Hospital = "MAC Los Mochis"
  //           break
  //         case "PRS":
  //           Hospital = "MAC Perisur"
  //           break
  //         case "PUE":
  //           Hospital = "MAC Puebla"
  //           break
  //         case "QRO":
  //           Hospital = "HMAS Querétaro"
  //           break
  //         case "SMA":
  //           Hospital = "MAC San Miguel de Allende"
  //           break
  //         case "TAM":
  //           Hospital = "MAC Tampico"
  //           break
  //         case "TIJ":
  //           Hospital = "MAC Tijuana"
  //           break
  //         case "TLA":
  //           Hospital = "MediMAC Tlalnepantla"
  //           break
  //         case "VIG":
  //           Hospital = "MAC La Viga"
  //           break
  //         default:
  //           Hospital = "Otro"
  //           break
  //       }

  //       if(Hospital !== "Otro"){
          
  //         let medicoObject = {
  //           "Nombre" :  medicos[i].Nombre_correcto,
  //           "Especialidad" : medicos[i].Especialidad_CRM,
  //           "Unidad_CRM" : HU,
  //           "Hospital" : Hospital,
  //           "Active" : true,
  //           "DTCreate" : time
  //         }
          
  //         //crearMedico(medicoObject)

  //         async function crearMedico(medicoObject) {
  //           console.log(medicoObject)
  //           const response = await createMedicoCRM(medicoObject)
  //           console.log(response)
  //         }
  //       }
  //     }
  //   }
  // },[])

  return(
    <div className="App">
      <ReservarCirugia />
    </div>
  )
}

export default App;
